import { Form } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { HostConfigurationEntity } from "src/app/features/HostConfiguration/types/HostConfigurationEntity";
import { TextInput } from "../../../../../components/Form/formComponents";
import { NumberInput } from "../../../../../components/Form/formComponents/Number/NumberInput";
import type { SearchFormProps } from "../../../../../components/Form/types/types";
import { SearchForm } from "../../../../../components/SearchForm/SearchForm";

export const HostConfigurationsSearchForm: FC<SearchFormProps<HostConfigurationEntity>> = ({ searchCallback }) => {
    const { t } = useTranslation();

    return (
        <SearchForm searchCallback={searchCallback}>
            <Form.Item label={t("form.name")} name="name">
                <TextInput name="name" />
            </Form.Item>
            <Form.Item label={t("form.system.id")} name="id">
                <NumberInput name="id" readOnly={false} />
            </Form.Item>
        </SearchForm>
    );
};
